import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import RuleActions from '../RuleActions';
import RuleConditions from '../RuleConditions';
import RuleName from '../RuleName';
import { useQuestionEditorContext } from 'components/Questionsv2/builder/context/create-question.context';
import QuestionRuleFields from 'components/Rules/QuestionRule';
import { removeQuestionRule } from 'rtk/Question.Editor.Slice';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionIsReadonly } from 'rtk/questionEditorSelector';
import { ERuleType } from 'types/rules.types';
import type { TQuestionRule } from 'types/rules.types';

interface Props {
  rule: TQuestionRule;
  ruleIdx: number;
}

const QuestionRule = ({ rule, ruleIdx }: Props) => {
  const { t } = useTranslation('Templates');
  const { questionId } = useQuestionEditorContext();
  const dispatch = useAppDispatch();
  const isReadOnly = useAppSelector((state) => selectQuestionIsReadonly(state, questionId));

  return (
    <QuestionRuleFields
      ruleIdx={ruleIdx}
      isReadOnly={isReadOnly}
      name={<RuleName rule={rule} ruleIdx={ruleIdx} />}
      onRemove={() => dispatch(removeQuestionRule({ questionId, ruleId: rule.id }))}
    >
      {rule.type === ERuleType.SHOW_IF ? (
        <RuleConditions rule={rule} />
      ) : rule.type === ERuleType.DO_IF ? (
        <Fragment>
          <RuleConditions rule={rule} />
          <RuleActions rule={rule} />
        </Fragment>
      ) : (
        <div>{t('question.rules.ruleErrors')}</div>
      )}
    </QuestionRuleFields>
  );
};

export default QuestionRule;
